import React, { Component } from 'react'
import styled from 'styled-components'

class WxUserAgreement extends Component {
  state = {
    content: `<b>服务协议</b>\n
    <b>导言</b>\n
    尊敬的用户：\n
    非常感谢您注册使用照护同道小程序，为让您更好地使用照护同道提供的产品和服务，请您务必审慎阅读、充分理解《照护同道用户协议》（以下称“用户协议”或“本协议”）各条款内容，特别是免除或者限制责任的条款，并选择接受或不接受。本协议中限制、免责条款可能以加粗形式提醒您注意。\n
    除非您已阅读并接受本协议所有条款，否则您无权下载、安装或使用照护同道提供相关产品和服务。您的下载、安装、使用、登陆等行为即视为您已阅读并同意本协议的约束。\n
    <b>1. 协议的范围</b>\n
    1.1 本用户协议是用户（您）与照护同道之间关于使用照护同道提供的产品和服务所订立的协议，本协议条款的效力及于照护同道所提供的一切产品和服务，用户在享受照护同道任何单项服务时，应当受本协议的约束。\n
    1.2 本协议项下的产品和服务是指由照护同道发布的包括但不限于网络媒体、互动娱乐、电子商务等的互联网产品和服务（形式包括但不限于在线视频、图片、软件、技术代码等）。\n
    1.3 照护同道有权根据需要不时地修订本协议及/或各类规则（包括但不限于制定新的条款和修改既有条款），并以在线公告的方式进行变更公告，无须另行单独通知您。修订后的协议和规则一经公布，立即或在公告明确的特定时间自动生效。若您在前述公告修订后继续使用照护同道的产品或服务，即视为您已阅读、理解并接受经过修订的协议和规则。若您不同意修订，应当立即停止使用照护同道提供的产品和服务。\n
    1.4 除本协议明确规定外，对于利用照护同道开发/发布的产品和服务，照护同道有权在本协议的基础上通过单独的产品和服务协议（以下称“单项产品协议”）加以规范，用户须在使用有关产品或服务时另行了解与确认。单项产品协议与本协议有冲突的地方，以单项产品协议为准。如用户使用该产品或服务，即视为对相关单项产品协议的接受。\n
    <b>2. 照护同道产品及服务简介</b>\n
    2.1 照护同道为用户提供管理患者的互联网产品和服务，包括但不限于查看培训视频、文档等相关产品，用户可以通过照护同道小程序使用照护同道提供的产品和服务。用户有权获得照护同道提供的产品和服务，但照护同道有权收取由此产生的服务或产品费用。\n
    2.2 照护同道运营者将尽力提供畅通无阻的在线服务，但平台的网络接入服务可能受多种因素的影响出现链接受阻、受限或被终止，由此给您带来的损失、不便，我们将不负任何责任。\n
    2.3 照护同道提供的部分产品和服务须付费使用，用户使用此类产品需要向照护同道运营者支付一定的费用。对于收费的产品和服务，我们会在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付相关费用，用户才能使用/继续使用该等收费产品和服务。如用户拒绝支付相关费用，则照护同道运营者有权不向用户提供该等收费产品和服务。\n
    2.4 照护同道仅提供在线产品和服务，除此之外与网络服务有关的设备（如手机、个人电脑、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。\n
    2.5照护同道的替换、修改和升级：\n
    2.5.1 为增进用户体验、完善服务内容，照护同道有权根据您对软件的使用状态和行为开发新的服务；\n
    2.5.2 为改进、增强和进一步开发服务，照护同道有权不时提供软件更新（包括软件升级替换、修改、功能强化、版本升级等形式）；\n
    2.5.3 用户理解并同意：照护同道有权不向您特别通知而对照护同道进行更新，或对照护同道的部分功能进行改变或限制。\n
    2.5.4 照护同道新版本发布后，旧版本可能无法使用。照护同道运营者不保证旧版照护同道及相应的服务继续可用。为充分、及时使用照护同道的服务，请您随时核对并下载最新版本。\n
    <b>3.知识产权声明</b>\n
    3.1 照护同道依法享有照护同道产品的一切合法权属（包括但不限于知识产权及所有权）。照护同道的全部著作权及其他一切知识产权，以及与照护同道相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、色彩组合、界面设计、版面框架、有关数据、印刷材料、或电子文档等均受中国知识产权相关法律法规和有关的国际条约的保护。\n
    3.2 照护同道产品及通过照护同道产品提供的视频、技术软件等产品和信息，除用户自己上传或明确标示由第三方提供的之外，全部权利归属于照护同道。\n
    3.3 照护同道产品中所体现的“照护同道”或照护同道产品和服务标识均属于照护同道在中国或其他国家、地区的商标或者注册商标，用户未经合法授权不得自行使用。\n
    3.4 照护同道在涉及照护同道产品及相关各项服务中拥有专利权、专利申请权、商标权、著作权及其他知识产权。照护同道并未因为本协议或者因为向用户提供照护同道以及相关产品和服务而授予用户任何与照护同道相关的知识产权。本协议未明确授予用户的权利均由照护同道保留。\n
    <b>4.用户隐私制度</b>\n
    4.1 保护用户个人信息是照护同道的一项基本原则。照护同道将按照本协议及《隐私政策》的规定收集、使用、储存和分享您的个人信息。本协议对个人信息的保护规定与《隐私政策》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《隐私政策》的内容为准。\n
    4.2 您在注册账号或使用照护同道产品和服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，可能无法使用照护同道的产品或服务，或在使用过程中受到限制。\n
    4.3 您可以随时浏览、修改自己提交的信息，但出于安全性和身份识别（如账号申诉服务）的考虑，您可能无法修改注册时提供的部分初始注册信息及其他验证信息。照护同道保留您修改个人信息的审核权。\n
    4.4 照护同道不会将您的个人信息转移或披露给任何非关联的第三方，除非：\n
      （1）相关法律法规或法院、政府机关要求；\n
      （2）为完成合并、分立、收购或资产转让而转移；\n
      （3）为提供您要求的服务所必须；\n
      （4）照护同道认定必要且不违反法律、法规强制性规定的其他情形。\n
    4.5 照护同道非常重视对未成年人信息的保护。若您是18周岁以下的未成年人，在使用照护同道的服务前，应事先取得您的法定监护人的同意。\n
    <b>5.用户的账号、密码和安全性</b>\n
    5.1 注册资格\n
    5.1.1 经您确认，在您完成注册程序或以其他照护同道允许的方式实际使用照护同道提供的产品和服务时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，且照护同道有权注销或永久冻结您的账户，并保留向您或您的监护人索取赔偿的权利。\n
    5.1.2 18周岁以下的未成年人等非完全民事行为能力人应该在法定监护人的指导下使用照护同道的产品和服务。\n
    5.2 注册与账户
    为完整使用照护同道提供的产品和服务，您须注册照护同道提供的账户。用户（您）注册照护同道账户时须对所提供信息的真实性、合法性、有效性及完整性负责，并及时维护和更新您的个人信息，以保证信息的真实、合法和有效。\n
    5.3 照护同道在此特别提醒您务必保护好您的账号及密码，切勿将账号及密码透露给他人。您须自行负责对您的账户和密码进行保密，且须对在您的账户和密码下发生的所有活动（包括但不限于信息披露、信息发布、网上点击同意或提交各类规则协议、网上续签协议或购买服务等）承担责任。照护同道不能也不会对因您未能遵守本条款规定而发生的任何损失负责。若您发现任何人未经授权使用您的账号及密码，您须立即通知照护同道。您可以发送邮件至help@ihealthlabs.com.cn提出您的请求。您须理解并同意照护同道根据您的请求采取行动需要合理时间，对在采取行动前已产生的任何不利后果，照护同道不承担任何责任。\n
    5.4 您可以对账户设置昵称，您设置的昵称不得侵犯或涉嫌侵犯他人的合法权益。用户承诺设置昵称时遵守以下规定：\n
      （1）不以党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名注册；\n
      （2）不以国家机构或其他机构的名称注册；\n
      （3）不注册不文明、不健康名字，或包含歧视、侮辱、猥亵类词语的账号；\n
      （4）不注册易产生歧义、引起他人误解或其它不符合法律规定的账号。\n
    如您设置的昵称涉嫌侵犯他人合法权益，照护同道有权终止向您提供部分或全部软件服务。照护同道对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。\n
    5.5 用户同意授权照护同道运营者基于下列原因使用用户的信息资源\n
      （1）执行软件验证、升级服务；\n
      （2）提高用户的使用安全性或提供客户支持；\n
      （3）应用户特殊要求而提供特定服务时，需要将信息提供给照护同道或与此相关联的第三方或其他用户；\n
      （4）将各种非个人隐私数据用于商业目的，包括但不限于向第三方提供增值服务、广告、定位广告、营销、联合注册、促销或其他活动等；\n
      （5）应司法机关或政府机关要求；\n
      （6）为提高用户使用体验；\n
      （7）其他有利于用户和照护同道利益且不违反任何强制性法律法规的情况。\n
    <b>6.照护同道使用规范</b>\n
    6.1 用户承诺在使用照护同道产品和服务过程中，不发布、转载、传送含有下列内容之一的内容，否则照护同道有权自行处理并不通知用户：\n
      （1）违反宪法确定的基本原则的；\n
      （2）危害国家安全，泄漏国家机密，颠覆国家政权，破坏国家统一的；\n
      （3）损害国家荣誉和利益的；\n
      （4）煽动民族仇恨、民族歧视，破坏民族团结的；\n
      （5）破坏国家宗教政策，宣扬邪教和封建迷信的；\n
      （6）散布谣言，扰乱社会秩序，破坏社会稳定的；\n
      （7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；\n
      （8）侮辱或者诽谤他人，侵害他人合法权益的；\n
      （9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；\n
      （10）以非法民间组织名义活动的；\n
      （11）含有法律、法规、规章禁止的其他内容的；\n
      （12）含有国家有关主管部门禁止的其他内容的。\n
    6.2 用户使用照护同道产品与服务时，承诺并遵守以下规定：\n
      （1）实施的所有行为均遵守国家法律、法规等规范性文件及照护同道各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议的相关规则。\n
      （2）不发布国家禁止的或涉嫌侵犯他人知识产权或其他合法权益的产品或服务信息，不发布违背社会公共利益或公共道德或照护同道认为不适合在照护同道上发布的产品或服务信息，不发布其他涉嫌违法或违反本协议及各类规则的信息。\n
      （3）除用户与照护同道另有约定，用户不得对照护同道中的任何数据/资料作商业性利用，包括但不限于在未经照护同道事先书面同意的情况下，以复制、传播等任何方式使用照护同道中展示的所有资料或课程。\n
      （4）不使用任何装置、软件或程序干预或试图干预照护同道的正常运作或正在照护同道平台上进行的任何交易和活动。\n
      （5）除法律另有强制性规定外，未经照护同道明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用照护同道 产品内的信息内容，否则，照护同道有权追究其法律责任。\n
      6.3 用户充分理解并同意：\n
      （1）用户如果违反前述承诺，产生任何法律后果的，用户应以自己的名义独立承担所有的法律责任，并确保照护同道免于因此产生的任何损失或增加费用。\n
      （2）用户如果违反法律或本协议规定造成照护同道被第三人索赔的，用户应全额补偿照护同道的一切费用（包括但不限于各种赔偿费、诉讼代理费及为此支出的其他合理费用）。\n
      （3）对于用户在照护同道中上传、发布、存储作品和内容，用户保证其对该等作品享有合法著作权/版权或者相应授权，并且用户同意授予照护同道对所有上述作品和内容的在全球范围内的免费、不可撤销的、无限期的、并且可转让的非独家使用权许可，照护同道有权展示、散布及推广前述内容，有权对前述内容进行任何形式的复制、修改、出版、发行及以其他方式使用或者授权第三方进行复制、修改、出版、发行及以其他方式使用。\n
      （4）对于用户在照护同道上涉嫌违法、违约或侵犯他人合法权利的内容、产品，照护同道有权不经通知予以删除，且不承担任何责任。\n
    <b>7.免责声明</b>\n
    7.1 用户理解并同意，在使用照护同道服务的过程中，可能会遇到不可抗力等风险因素，使服务发生中断、延迟。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害（如洪水、台风、地震等）、社会事件（如战争、暴动、政府行为）等，出现上述情况时，照护同道会努力对产品和服务进行修复，但由此给您造成的损失，照护同道在法律允许的范围内免责。\n
    7.2 在法律允许的范围内，照护同道对以下情形导致的服务终端或受阻不承担责任：\n
      （1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；\n
      （2）用户或照护同道的电脑软件、系统、硬件和通信线路出现故障；\n
      （3）用户操作不当；\n
      （4）用户使用非照护同道授权的方式使用本服务；\n
      （5）其他照护同道无法控制或合理预见的情形。\n
    7.3 用户理解并同意，在使用照护同道产品和服务的过程中，可能会遇到网络信息或其他用户带来的风险和损害，照护同道不对任何信息或产品的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：\n
      （1）来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；\n
      （2）因使用本协议项下产品或服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理以及经济上的损害。\n
    7.4 照护同道依据本协议享有处理不法、违规内容、产品或服务的权利，但该权利不构成照护同道的义务和承诺，照护同道不保证及时发现并做出相应处理。\n
    7.5 对于单项产品运营者通过照护同道向您提供的单项产品或服务，由单项产品运营者独立承担与该项产品或服务有关的全部责任和义务，其他照护同道对此不承担任何责任和义务。\n
    <b>8.产品/服务的变更、中止或结束</b>\n
    8.1 用户应规范、合法地使用照护同道及服务，如用户发布违法、违背社会公德或违背本协议约定的信息，或有违反相关法律法规或本协议的行为，照护同道有权采取以下措施：\n
      （1）直接删除违反法律法规或本协议的内容；\n
      （2）中止或限制您使用照护同道及其产品和服务的权利，包括但不限于限制您使用照护同道部分或全部功能及产品、服务等；\n
      （3）终止您使用照护同道的权利；\n
      （4）回收您的账号，同时有权禁止您申请或通过其他方式取得新的账号；\n
      （5）依法追究您的法律责任，索取相应损害赔偿金。\n
    8.2 照护同道有权根据业务发展需要中止、变更、终止照护同道产品或其部分功能，并有权决定是否（继续）提供照护同道中的某种产品和服务；对于前述情形，照护同道并不负有向用户通知的义务。\n
    8.3 除法律另有规定外，用户有责任自行备份存储在照护同道的数据，如用户的服务被终止，照护同道运营者有权从服务器上永久地删除您在照护同道的全部相关数据，并不负有向您返还或以任何形式提供前述数据的义务。\n
    <b>9.适用法律及争议解决方式</b>\n
    9.1 本协议签订地为中华人民共和国北京市海淀区。\n
    9.2 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。\n
    9.3 若您与照护同道运营者发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交至北京仲裁委员会在北京仲裁解决。仲裁裁决是终局的，对双方均有约束力。\n
    <b>10.其他规定</b>\n
    10.1 如本协议中的任何条款因任何原因部分无效或不具有执行力，不影响本协议中其余条款对双方的约束力。\n
    10.2 本协议条款的标题仅为方便阅读而设，不作为解释本协议条款的依据。\n`,
  }
  render() {
    return (
      <RootView>
        <TextContent
          dangerouslySetInnerHTML={{ __html: this.state.content }}
        ></TextContent>
      </RootView>
    )
  }
}

export default WxUserAgreement

const RootView = styled.div`
  background-color: white;
  flex-direction: column;
  width: 100%;
  height: 100%;
`
const TextContent = styled.div`
  padding: 10px;
  white-space: pre-line;
  word-break: break-all;
`



// WEBPACK FOOTER //
// ./src/modules/activity/components/wxUserAgreement.js